import RightNav from "./RightNav";
import { useCartData } from "hooks/useDataFetch";
import { useAppContext } from "contexts";
import React, { useState, useEffect } from "react";
import { Avatar, Badge, Container } from "@mui/material";
import { NavLink } from "react-router-dom";
import {
  Search,
  LocationOn,
  PermIdentity,
  ShoppingBagOutlined,
} from "@mui/icons-material";

import { Logo } from "asset";
// import RightNav from "./RightNav";

const MainNavbar = () => {
  const navigation = [
    {
      name: "Home",
      path: "/",
    },
    {
      name: "About Us",
      path: "/about",
    },
    {
      name: "Order Now",
      path: "/ordernow",
    },

    {
      name: "Contact Us",
      path: "/contact",
    },
    {
      name: "Donate",
      path: "/donate",
    },
  ];

  //search bar nolonger needed

  // const searchField = useRef(null);

  // const [searchBar, setSearchBar] = useState(false);

  // useClickArea(searchField, () => {
  //   setSearchBar(false);
  // });

  const { data } = useCartData();

  const { user } = useAppContext();

  return (
    <>
      <div className="navbar-header-bottom flex-row justify-content-center">
        <Container>
          <div className="navbar-header-bottom-container flex-row justify-content-between ">
            <div className="responsive-navbar">
              <RightNav />
            </div>
            <div className="navbar-header-bottom-logo flex-row align-items-center ">
              <NavLink
                to="/"
                className="flex-row align-items-center justify-content-center"
              >
                <img src={Logo} alt="Fresh Vial" />
              </NavLink>
            </div>
            <div className="navbar-header-bottom-menu flex-row align-items-center nav-off ">
              <ul className="navbar-header-bottom-menu-ul flex-row justify-content-between gap-1 w-100  ">
                {navigation.map((item, index) => {
                  return (
                    <li className="navbar-header-bottom-menu-li" key={index}>
                      <NavLink
                        className="navbar-header-bottom-menu-a"
                        to={item.path}
                      >
                        {item.name}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="navbar-header-bottom-cart flex-row align-items-center gap-2 nav-off">
              <NavLink to={"/search"}>
                <span className="navbar-header-bottom-cart-span nav-search-icon flex-row align-items-center ">
                  <span className="flex-row align-items-center justify-content-center">
                    <Search />
                  </span>
                </span>
              </NavLink>
              {user?.uid ? (
                <>
                  <span className="navbar-header-bottom-cart-span flex-row align-items-center ">
                    <NavLink to="/cart">
                      <Badge badgeContent={data?.length || 0} color="info">
                        <ShoppingBagOutlined />
                      </Badge>
                    </NavLink>
                  </span>
                  <span className="navbar-header-bottom-cart-span flex-row align-items-center ">
                    <NavLink to="/profile">
                      <Avatar>
                        {user?.displayName && user?.displayName[0]}
                      </Avatar>
                    </NavLink>
                  </span>
                </>
              ) : (
                <>
                  <span className="navbar-header-bottom-cart-span flex-row align-items-center ">
                    <NavLink to="/login?redirect=/cart">
                      <Badge>
                        <ShoppingBagOutlined />
                      </Badge>
                    </NavLink>
                  </span>
                  <span className="navbar-header-bottom-cart-span flex-row align-items-center ">
                    <NavLink to="/login?redirect=/profile ">
                      <PermIdentity />
                    </NavLink>
                  </span>
                </>
              )}
              {/* <span className="navbar-header-bottom-cart-span-btn">
                <Button>Buy Now</Button>
              </span> */}
            </div>
          </div>
        </Container>
        {/* //searchbar nolonger needed */}
        {/* {searchBar && (
          <span
            className="navbar-search-field-body flex-column gap-2"
            ref={searchField}
          >
            <span className="navbar-search-field flex-row align-items-center">
              <TextField
                className="w-100"
                placeholder="search for product and suppliers"
              />{" "}
              <Button className="navbar-search-field-btn">
                {" "}
                <Search />{" "}
              </Button>
            </span>

            <span className="navbar-search-results flex-column gap-1">
              <span className="navbar-search-results-item w-100 flex-row  gap-1">
                <span className="navbar-search-results-item-img flex-row align-items-center justify-content-center">
                  <img src="https://picsum.photos/200/300" alt="" />
                </span>

                <span className="navbar-search-results-item-details flex-column justify-content-between">
                  <h3 className="navbar-search-results-item-details-name">
                    Voss Water 330ml
                  </h3>

                  <span className="search-item-quantity flex-column gap-1 ">
                    <p className="search-item-quantity-p flex-row align-items-center  ">
                      Quantity :{" "}
                      <span className="search-item-quantity-p-span">
                        {" "}
                        330ml{" "}
                      </span>
                    </p>
                    <p className="search-item-quantity-p flex-row align-items-center  ">
                      Supplier :{" "}
                      <span className="search-item-quantity-p-span">
                        {" "}
                        Voss Water{" "}
                      </span>
                    </p>
                  </span>

                  <span className="navbar-search-item-pricing">SAR 500</span>
                </span>
              </span>
            </span>
          </span>
        )} */}
      </div>
    </>
  );
};

const Navbar = () => {
  const [scrollNav, setScrollNav] = useState(false);
  const handleScroll = () => {
    if (window.scrollY > 200) {
      setScrollNav(true);
    } else return setScrollNav(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // console.log(scrollNav);
  return (
    <>
      <nav className="navbar-main">
        <div className="navbar-header-top flex-row align-items-center nav-off ">
          <Container>
            <div className="navbar-header-top-container flex-row justify-content-between ">
              <span className="navbar-header-top-span">
                Phone:(+91) 9876543210
              </span>
              <span className="navbar-header-top-span">
                Opening Hours : Monday To Saturday - 8AM TO 8PM
              </span>
              <span className="navbar-header-top-span flex-row align-items-center ">
                <LocationOn /> Bhubanesware ,Odisha,India.
              </span>
            </div>
          </Container>
        </div>
        <MainNavbar />
      </nav>

      {scrollNav && (
        <div className="sticky-navbar">
          <MainNavbar />
        </div>
      )}
    </>
  );
};

export default Navbar;
